const WPP_PROJECT_ID_KEY = "ic:wppProjectId";

// WPP Open pushes the project over postMessage, and that push can be slow or fail
// outright on a reload. Remember the last project we were given for the tab so
// queries can still scope to it instead of falling back to an unscoped "everything".
export const readCachedWppProjectId = (): string | undefined => {
    try {
        return sessionStorage.getItem(WPP_PROJECT_ID_KEY) ?? undefined;
    } catch {
        // sessionStorage can be unavailable (e.g. partitioned/blocked storage).
        return undefined;
    }
};

export const cacheWppProjectId = (projectId: string): void => {
    try {
        sessionStorage.setItem(WPP_PROJECT_ID_KEY, projectId);
    } catch {
        // ignore
    }
};

export const clearCachedWppProjectId = (): void => {
    try {
        sessionStorage.removeItem(WPP_PROJECT_ID_KEY);
    } catch {
        // ignore
    }
};
